module.exports = "/images/bathroom_women.png?7126d2444d8160005d1ab54d9bae82b8";